<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{ pageTitle }}</div>
                    <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="goToList">
                        <span>Back</span>
                    </button>
                </div>

                <div class="forms-container approval-form-shell">
                    <div v-if="successMessage" class="approval-alert approval-alert-success">
                        {{ successMessage }}
                    </div>
                    <div v-if="errorMessage" class="approval-alert approval-alert-error">
                        {{ errorMessage }}
                    </div>

                    <form v-on:submit.prevent="submitForm">
                        <div class="row approval-form-grid">
                            <div class="col-12 col-md-6 approval-field">
                                <label for="Dealership">Dealership <span>*</span></label>
                                <select id="Dealership" v-model="form.Dealership" class="form-control" tabindex="1">
                                    <option value="">Select dealership</option>
                                    <option v-for="option in dealershipOptions" :key="option" :value="option">{{ option }}</option>
                                </select>
                                <div class="help is-danger">{{ fieldError('Dealership') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="Make">Make <span>*</span></label>
                                <select id="Make" v-model="form.Make" class="form-control" tabindex="2">
                                    <option value="">Select make</option>
                                    <option v-for="option in makeOptions" :key="option.value" :value="option.value">{{ option.text }}</option>
                                </select>
                                <div class="help is-danger">{{ fieldError('Make') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="DealNumber">Deal Number <span>*</span></label>
                                <input id="DealNumber" v-model="form.DealNumber" type="text" class="form-control" placeholder="Enter deal number" maxlength="100" tabindex="3">
                                <div class="help is-danger">{{ fieldError('DealNumber') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="Series">Series <span>*</span></label>
                                <select id="Series" v-model="form.Series" class="form-control" tabindex="4">
                                    <option value="">Select series</option>
                                    <option v-for="option in seriesOptions" :key="option" :value="option">{{ option }}</option>
                                </select>
                                <div class="help is-danger">{{ fieldError('Series') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="RequestGPAmount">Request GP Amount <span>*</span></label>
                                <input id="RequestGPAmount" v-model="form.RequestGPAmount" type="number" min="0" step="0.01" class="form-control" placeholder="Enter requested GP amount" tabindex="5">
                                <div class="help is-danger">{{ fieldError('RequestGPAmount') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="UnitId">Unit ID <span>*</span></label>
                                <input id="UnitId" v-model="form.UnitId" type="text" class="form-control" placeholder="Enter unit ID" maxlength="6" tabindex="6" v-on:input="form.UnitId = form.UnitId.replace(/[^0-9]/g, '')">
                                <div class="help is-danger">{{ fieldError('UnitId') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="CommissionNumber">Commission Number</label>
                                <input id="CommissionNumber" v-model="form.CommissionNumber" type="text" class="form-control" placeholder="Enter commission number" maxlength="100" tabindex="7">
                                <div class="help is-danger">{{ fieldError('CommissionNumber') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="BodyType">Body Type</label>
                                <input id="BodyType" v-model="form.BodyType" type="text" class="form-control" placeholder="Enter body type" maxlength="100" tabindex="8">
                                <div class="help is-danger">{{ fieldError('BodyType') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="AgeOfVehicle">Age Of Vehicle (In Days)</label>
                                <input id="AgeOfVehicle" v-model="form.AgeOfVehicle" type="number" min="0" class="form-control" placeholder="Enter age" tabindex="9">
                                <div class="help is-danger">{{ fieldError('AgeOfVehicle') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="DeliveryDate">Delivery Date <span>*</span></label>
                                <input id="DeliveryDate" v-model="form.DeliveryDate" type="date" class="form-control" tabindex="10">
                                <div class="help is-danger">{{ fieldError('DeliveryDate') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="CustomerName">Customer Name <span>*</span></label>
                                <input id="CustomerName" v-model="form.CustomerName" type="text" class="form-control" placeholder="Enter customer name" maxlength="150" tabindex="11">
                                <div class="help is-danger">{{ fieldError('CustomerName') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="CustomerType">Customer Type <span>*</span></label>
                                <select id="CustomerType" v-model="form.CustomerType" class="form-control" tabindex="12">
                                    <option value="">Select customer type</option>
                                    <option v-for="option in customerTypeOptions" :key="option" :value="option">{{ option }}</option>
                                </select>
                                <div class="help is-danger">{{ fieldError('CustomerType') }}</div>
                            </div>

                            <div v-if="form.CustomerType === 'OTHER CUSTOMER'" class="col-12 col-md-6 approval-field">
                                <label for="OtherCustomerType">Other Customer Type <span>*</span></label>
                                <input id="OtherCustomerType" v-model="form.OtherCustomerType" type="text" class="form-control" placeholder="Enter other customer name" maxlength="150" tabindex="13">
                                <div class="help is-danger">{{ fieldError('OtherCustomerType') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="SubmittedByName">Submitter Name</label>
                                <input id="SubmittedByName" v-model="form.SubmittedByName" type="text" class="form-control" placeholder="Enter submitter name" maxlength="150" readonly tabindex="14">
                                <div class="help is-danger">{{ fieldError('SubmittedByName') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="SubmittedBy">Submitter Email</label>
                                <input id="SubmittedBy" v-model="form.SubmittedBy" type="email" class="form-control" placeholder="name@example.com" maxlength="150" readonly tabindex="15">
                                <div class="help is-danger">{{ fieldError('SubmittedBy') }}</div>
                            </div>

                            <div class="col-12 col-md-6 approval-field">
                                <label for="SendTo">Send Request To <span>*</span></label>
                                <select id="SendTo" v-model="form.SendTo" class="form-control" tabindex="16">
                                    <option value="">Select recipient</option>
                                    <option v-for="option in recipientOptions" :key="option.email" :value="option.email">{{ option.name }}</option>
                                </select>
                                <div class="help is-danger">{{ fieldError('SendTo') }}</div>
                            </div>

                            <div class="col-12 approval-field">
                                <label for="ReasonLowGP">Reason Low GP <span>*</span></label>
                                <textarea id="ReasonLowGP" v-model="form.ReasonLowGP" rows="5" class="form-control no-resize" placeholder="Explain why low GP approval is required" :maxlength="maxReasonLength" tabindex="17"></textarea>
                                <div class="quote-hint">{{ reasonLength }} / {{ maxReasonLength }} characters</div>
                                <div class="help is-danger">{{ fieldError('ReasonLowGP') }}</div>
                            </div>

                            <div class="col-12 approval-actions">
                                <button type="button" class="ml-2 btn btn-primary pull-right themebutton cancelbutton" tabindex="19" v-on:click="resetForm" :disabled="isSubmitting">
                                    <span>Reset</span>
                                </button>
                                <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" tabindex="18" :disabled="isSubmitting">
                                    <span>{{ isSubmitting ? 'Submitting...' : 'Submit For Approval' }}</span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import Footer from '@/components/partials/Footer';
    import {HTTP} from '../../http-common.js';

    export default {
        name: 'LowGPFormSubmission',
        components: {
            'app-footer': Footer,
        },
        data() {
            return {
                form: this.defaultForm(),
                errors: {},
                successMessage: '',
                errorMessage: '',
                isSubmitting: false,
                recipientOptions: [],
                maxReasonLength: 1000,
                dealershipOptions: [
                    'Daimler Trucks Brisbane',
                    'Daimler Trucks Gold Coast',
                    'Daimler Trucks Newcastle',
                    'Daimler Trucks Huntingwood',
                    'Daimler Trucks Milperra',
                    'Daimler Trucks Dandenong',
                    'Fuso Port Melbourne',
                    'Daimler Trucks Laverton',
                    'Daimler Trucks Geelong',
                    'Daimler Trucks Ballarat',
                    'Daimler Trucks Somerton',
                    'Daimler Trucks Adelaide',
                    'Fuso Adelaide',
                    'Mildura',
                    'Mt Gambier',
                    'Daimler Trucks Perth',
                ],
                makeOptions: [
                    { value: 'MB', text: 'MB' },
                    { value: 'FL', text: 'FL' },
                    { value: 'FUSO', text: 'FUSO' },
                ],
                seriesOptionsByMake: {
                    MB: [
                        'ACTROS',
                        'ATEGO',
                        'AROCS',
                        'ECONIC',
                        'UNIMOG',
                        'eACTROS',
                        'eECONIC',
                        'eATEGO',
                    ],
                    FL: [
                        'CASCADIA',
                    ],
                    FUSO: [
                        'CANTER',
                        'FIGHTER',
                        'SHOGUN',
                        'ROSA',
                        'eCANTER',
                    ],
                },
                customerTypeOptions: [
                    'DAIMLER FLEET CUSTOMER',
                    'LONG STANDING CUSTOMER - OVERSEAS DELIVERY',
                    'LONG STANDING CUSTOMER - DOMESTIC DELIVERY',
                    'VTC FLEET CUSTOMER',
                    'GOVERNMENT/COUNCIL CUSTOMER',
                    'FLEET MANAGEMENT ORGANISATION CUSTOMER',
                    'DTFS CUSTOMER',
                    'INSURANCE COMPANY',
                    'OTHER CUSTOMER',
                ],
            };
        },
        computed: {
            pageTitle() {
                return 'Low GP Form';
            },
            endpoint() {
                return 'low-gp-forms';
            },
            listRouteName() {
                return 'LowGPFormList';
            },
            seriesOptions() {
                return this.seriesOptionsByMake[this.form.Make] || [];
            },
            reasonLength() {
                return (this.form.ReasonLowGP || '').length;
            },
        },
        watch: {
            '$route.name': function () {
                this.resetForm();
            },
            'form.Make': function () {
                if (this.seriesOptions.indexOf(this.form.Series) === -1) {
                    this.form.Series = '';
                }
                this.selectDefaultSeriesIfNeeded();
            },
        },
        mounted() {
            this.form.SubmittedByName = this.submitterName();
            this.form.SubmittedBy = this.submitterEmail();
            this.selectDefaultSeriesIfNeeded();
            this.loadRecipients();
        },
        methods: {
            defaultForm() {
                return {
                    Dealership: '',
                    DealNumber: '',
                    Make: '',
                    Series: '',
                    UnitId: '',
                    CommissionNumber: '',
                    BodyType: '',
                    AgeOfVehicle: '',
                    CustomerName: '',
                    CustomerType: '',
                    OtherCustomerType: '',
                    DeliveryDate: '',
                    RequestGPAmount: '',
                    ReasonLowGP: '',
                    SubmittedByName: '',
                    SubmittedBy: '',
                    SendTo: '',
                };
            },
            loadRecipients() {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };

                HTTP.get('/approval-form-recipients', config).then(function (response) {
                    self.recipientOptions = (response.data && response.data.data) || [];
                }).catch(function () {
                    self.errorMessage = 'Unable to load the recipient list. Please refresh the page and try again.';
                });
            },
            submitterName() {
                try {
                    var user = JSON.parse(localStorage.getItem('user_obj') || '{}');
                    var firstName = user.first_name || '';
                    var lastName = user.last_name || '';
                    var fullName = (firstName + ' ' + lastName).trim();

                    return fullName || user.username || '';
                } catch (e) {
                    return '';
                }
            },
            submitterEmail() {
                try {
                    var user = JSON.parse(localStorage.getItem('user_obj') || '{}');
                    return user.username || '';
                } catch (e) {
                    return '';
                }
            },
            selectDefaultSeriesIfNeeded() {
                if (this.seriesOptions.length === 1) {
                    this.form.Series = this.seriesOptions[0];
                }
            },
            fieldError(field) {
                return this.errors[field] ? this.errors[field][0] : '';
            },
            validateForm() {
                var errors = {};
                var requiredFields = ['Dealership', 'DealNumber', 'Make', 'Series', 'UnitId', 'CustomerName', 'CustomerType', 'DeliveryDate', 'ReasonLowGP', 'RequestGPAmount', 'SendTo'];

                if (this.form.CustomerType === 'OTHER CUSTOMER') {
                    requiredFields.push('OtherCustomerType');
                }

                requiredFields.forEach((field) => {
                    if (this.form[field] === null || this.form[field] === '') {
                        errors[field] = ['This field is required.'];
                    }
                });

                if (this.form.DeliveryDate) {
                    var today = new Date();
                    today.setHours(0, 0, 0, 0);
                    var selected = new Date(this.form.DeliveryDate + 'T00:00:00');
                    if (selected < today) {
                        errors.DeliveryDate = ['Delivery date must be a future date.'];
                    }
                }

                if (this.form.RequestGPAmount !== '' && isNaN(Number(this.form.RequestGPAmount))) {
                    errors.RequestGPAmount = ['Please enter a valid amount.'];
                }

                this.errors = errors;
                return Object.keys(errors).length === 0;
            },
            payload() {
                var payload = Object.assign({}, this.form);
                payload.SubmittedByName = this.submitterName();
                payload.SubmittedBy = this.submitterEmail();

                if (payload.AgeOfVehicle === '') {
                    payload.AgeOfVehicle = null;
                }

                Object.keys(payload).forEach((key) => {
                    if (payload[key] === '') {
                        payload[key] = null;
                    }
                });

                return payload;
            },
            submitForm() {
                var self = this;

                self.successMessage = '';
                self.errorMessage = '';

                if (!self.validateForm()) {
                    self.errorMessage = 'Please complete the required fields.';
                    return;
                }

                self.isSubmitting = true;

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };

                HTTP.post('/' + self.endpoint, self.payload(), config).then(function () {
                    self.$router.push({ name: self.listRouteName, query: { success: self.pageTitle + ' submitted successfully.' } });
                }).catch(function (err) {
                    if (err.response && err.response.status === 401) {
                        var currentBuild = window.localStorage.getItem('build_version');
                        localStorage.clear();
                        localStorage.setItem('build_version', currentBuild);
                        alert('Your session has expired. You will be redirected to the login page.');
                        window.location.href = process.env.SSO_ROOT_URL + '/login?redirect=' + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                        return;
                    }
                    if (err.response && err.response.data && err.response.data.errors) {
                        self.errors = err.response.data.errors;
                        self.errorMessage = 'Please review the highlighted fields.';
                    } else if (err.response && err.response.data && err.response.data.message) {
                        self.errorMessage = err.response.data.message;
                    } else {
                        self.errorMessage = 'Unable to submit the form. Please try again.';
                    }
                    self.isSubmitting = false;
                }).then(function () {
                    self.isSubmitting = false;
                });
            },
            goToList() {
                this.$router.push({ name: this.listRouteName });
            },
            resetForm(keepSuccessMessage) {
                var successMessage = keepSuccessMessage === true ? this.successMessage : '';
                this.form = this.defaultForm();
                this.form.SubmittedByName = this.submitterName();
                this.form.SubmittedBy = this.submitterEmail();
                this.errors = {};
                this.errorMessage = '';
                this.successMessage = successMessage;
            },
        },
    };
</script>

<style scoped>
    .approval-form-shell {
        background: #ffffff;
        border: 1px solid #d8e0e6;
        border-radius: 6px;
        box-shadow: 0 4px 16px rgba(31, 45, 61, 0.08);
        margin-top: 24px;
        padding: 34px 36px 28px;
    }

    .approval-form-grid {
        margin-left: -14px;
        margin-right: -14px;
    }

    .approval-field {
        margin-bottom: 22px;
        padding-left: 14px;
        padding-right: 14px;
    }

    .approval-field label {
        color: #2f3337;
        display: block;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 8px;
    }

    .approval-field label span {
        color: #d22f2f;
    }

    .approval-actions {
        padding-left: 14px;
        padding-right: 14px;
        padding-top: 6px;
    }

    .approval-form-shell .form-control {
        min-height: 42px;
    }

    .approval-form-shell textarea.form-control {
        min-height: 120px;
    }

    .quote-hint {
        color: #6a7581;
        font-size: 13px;
        margin-top: 6px;
    }

    .approval-alert {
        border-radius: 4px;
        font-size: 14px;
        margin-bottom: 18px;
        padding: 12px 14px;
    }

    .approval-alert-success {
        background: #edf8f0;
        border: 1px solid #b9e4c4;
        color: #246b35;
    }

    .approval-alert-error {
        background: #fff1f1;
        border: 1px solid #f0baba;
        color: #9d2525;
    }

    @media (max-width: 767px) {
        .approval-form-shell {
            margin-top: 18px;
            padding: 22px 18px 20px;
        }

        .approval-form-grid {
            margin-left: -8px;
            margin-right: -8px;
        }

        .approval-field,
        .approval-actions {
            padding-left: 8px;
            padding-right: 8px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ApprovalForms/LowGPFormSubmission.vue